"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.364 11.09h.909a2.727 2.727 0 110 5.456h-.91v3.181A2.278 2.278 0 0116.092 22h-3.91v-1.818a2.001 2.001 0 00-4 0V22H4.274A2.278 2.278 0 012 19.727v-3.909h1.818a2.001 2.001 0 000-4H2.01V7.91a2.27 2.27 0 012.264-2.273h3.182v-.909a2.727 2.727 0 115.454 0v.91h3.182a2.278 2.278 0 012.273 2.272v3.182zm-2.273 10c.749 0 1.363-.614 1.363-1.363v-4.09h1.819a1.818 1.818 0 000-3.637h-1.819V7.91c0-.75-.614-1.365-1.363-1.365H12V4.727a1.818 1.818 0 00-3.636 0v1.818H4.273c-.747 0-1.355.612-1.355 1.364v3h.9a2.91 2.91 0 012.91 2.91 2.91 2.91 0 01-2.91 2.908H2.91v3c0 .75.615 1.364 1.364 1.364h3v-.91a2.91 2.91 0 012.909-2.908 2.91 2.91 0 012.909 2.909v.909h3z"
  }));
}

var _default = SvgApps;
exports["default"] = _default;